import Image, { StaticImageData } from "next/image";
import logo from "@public/svg/logo.svg";
import { cn } from "@/lib/utils";

interface LogoProps {
  src?: StaticImageData | string;
  width?: number;
  height?: number;
  className?: string;
}

const Logo = ({ src, width, height, className, ...props }: LogoProps) => {
  return (
    <Image
      src={src || logo}
      width={width || 0}
      height={height || 0}
      alt={"سامانه نوین"}
      title={"سامانه نوین"}
      className={cn(className)}
      {...props}
    />
  );
};

export default Logo;
